import React, { useEffect, useState } from "react";
import images from "../../../Utils/importImages";
import SelectTag from "../Components/Inputs/SelectTag";
import CustomAutoComplete from "../Components/Inputs/CustomAutoComplete";
import {
  getCountriesData,
  getStatesData,
} from "../../../Redux/Apis/Global-Apis";
import TextField from "../Components/Inputs/TextField";
import { isValidPhoneNumber } from "libphonenumber-js";
import CustomAutoCompleteWithImg from "../Components/Inputs/CustomAutoCompleteWithImg";
import { useSelector } from "react-redux";

function TravellerForm({ Data, onClickCancel, onClickSave }) {
  let userDC = useSelector(
    (state) => state.user.UserCurrentLocationData.dial_code
  );

  let [travellerData, setTravellerData] = useState(Data);

  const getMatureStatus = (dob) => {
    if (!dob) return;
    if (dob.includes("DD") || dob.includes("MM") || dob.includes("YYYY"))
      return;

    // Convert DOB to a Date object
    let birthDate = new Date(dob);
    if (isNaN(birthDate)) return; // Invalid date check

    // Calculate age
    let today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    let monthDiff = today.getMonth() - birthDate.getMonth();
    let dayDiff = today.getDate() - birthDate.getDate();

    // Adjust age if birthdate hasn't occurred yet this year
    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
      age--;
    }

    // Determine status based on age
    if (age < 2) return "Infant";
    if (age >= 2 && age < 12) return "Child";
    if (age >= 12 && age < 60) return "Adult";
    return "Senior Citizen";
  };

  let onChangeInput = (e) => {
    setTravellerData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const days = Array.from({ length: 31 }, (_, i) => ({
    label: i + 1 < 10 ? `0${i + 1}` : i + 1,
    value: i + 1 < 10 ? `0${i + 1}` : i + 1,
  }));

  const months = [
    { label: "MM", value: "MM" },
    { label: "Jan", value: "01" },
    { label: "Feb", value: "02" },
    { label: "Mar", value: "03" },
    { label: "Apr", value: "04" },
    { label: "May", value: "05" },
    { label: "Jun", value: "06" },
    { label: "Jul", value: "07" },
    { label: "Aug", value: "08" },
    { label: "Sep", value: "09" },
    { label: "Oct", value: "10" },
    { label: "Nov", value: "11" },
    { label: "Dec", value: "12" },
  ];

  const currentYear = new Date().getFullYear();

  const years = Array.from({ length: 100 }, (_, i) => ({
    label: currentYear - i,
    value: currentYear - i,
  }));

  const onChangeDate = (field, value) => {
    let prevDob =
      travellerData?.date_of_birth == null
        ? "YYYY-MM-DD"
        : travellerData.date_of_birth;

    let currentDOB = prevDob ? prevDob.split("-") : ["YYYY", "MM", "DD"];

    if (field === "day") currentDOB[2] = value.value;
    if (field === "month") currentDOB[1] = value.value;
    if (field === "year") currentDOB[0] = value.value;
    let finalDob = currentDOB.join("-");

    setTravellerData((prev) => {
      return {
        ...prev,
        date_of_birth: finalDob,
      };
    });
  };

  const onChangeDateV2 = (field, value, key) => {
    let prevDate =
      travellerData?.[key] == null ? "YYYY-MM-DD" : travellerData?.[key];

    let currentDOB = prevDate ? prevDate.split("-") : ["YYYY", "MM", "DD"];

    if (field === "day") currentDOB[2] = value.value;
    if (field === "month") currentDOB[1] = value.value;
    if (field === "year") currentDOB[0] = value.value;
    let finalDob = currentDOB.join("-");

    setTravellerData((prev) => {
      return {
        ...prev,
        [key]: finalDob,
      };
    });
  };

  const onChangeGender = (field, value) => {
    setTravellerData((prev) => ({
      ...prev,
      [field]: value.value,
    }));
  };

  const onChangeTitle = (field, value) => {
    setTravellerData((prev) => ({
      ...prev,
      [field]: value.value,
    }));
  };

  let getDateValue = (val) => {
    if (!val) return { label: "DD", value: null };
    return { label: val, value: val };
  };

  let getMonthValue = (val) => {
    console.log("value is : ", val);

    if (!val) return { label: "MM", value: null };
    return {
      label: months.filter((item) => item.value == val)[0].label,
      value: val,
    };
  };

  let getYearValue = (val) => {
    if (!val) return { label: "YYYY", value: null };
    return { label: val, value: val };
  };

  let getTitleValue = (val) => {
    if (!val) return { label: "Title", value: null };

    return {
      label: val,
      value: val,
    };
  };

  let getGenderValue = (val) => {
    if (!val) return { label: "Gender", value: null };

    return {
      label: val.charAt(0).toUpperCase() + val.slice(1),
      value: val,
    };
  };

  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);

  const [DialcodeCountries, setDialcodeCountries] = useState([]);
  const [seletedDialCodeCountry, setSeletedDialCodeCountry] = useState(null);

  useEffect(() => {
    const fetchCountries = async () => {
      let data = await getCountriesData();
      console.log("data is : ", data);

      if (data.length > 0) {
        let dm = data.map((item) => ({
          label: item.name,
          value: item.code,
          data: item,
        }));

        setCountries(dm);

        let dd = data.map((item) => ({
          label: `${item.code}:${item.phone}:${item.name}`,
          value: item.phone,
          data: item,
        }));

        let usercc = dd.filter((item) => item.value == userDC);
        setSeletedDialCodeCountry(usercc[0]);
        setDialcodeCountries(dd);
      }
    };

    fetchCountries();
  }, []);

  useEffect(() => {
    const fetchStates = async () => {
      if (travellerData.country_id != null) {
        let data = await getStatesData(travellerData.country_id);

        if (data.length > 0) {
          let dd = data.map((item) => ({
            label: item.name,
            value: item.id,
            data: item,
          }));

          setStates(dd);
        }
      }
    };

    fetchStates();
  }, [travellerData.country_id]);

  let getCountryValue = (val) => {
    if (!val) return { label: "Select Country", value: null, data: null };

    return {
      label: val.name,
      value: val.code,
      data: val,
    };
  };

  let getStatesValue = (val) => {
    console.log("get state val is : ", val);

    if (!val) return { label: "Select State", value: null, data: null };

    return {
      label: val.name,
      value: val.id,
      data: val,
    };
  };

  let onChangeCountry = (value) => {
    console.log("countrychange value si : ", value);

    setTravellerData((prev) => ({
      ...prev,
      country: value.data,
      country_id: value.data.code,
      state: null,
      state_id: null,
    }));
  };

  let onChangeDialCodeCountry = (value) => {
    console.log("countrychange value si : ", value);

    setSeletedDialCodeCountry(value);
  };

  let onChangeState = (value) => {
    console.log("state value si : ", value);

    setTravellerData((prev) => ({
      ...prev,
      state: value.data,
      state_id: value.data.id,
    }));
  };

  let getYears = (sign) => {
    const operations = {
      "+": (a, b) => a + b,
      "-": (a, b) => a - b,
      "*": (a, b) => a * b,
      "/": (a, b) => a / b,
    };

    if (!operations[sign]) {
      console.error("Invalid operator. Use +, -, *, or /");
      return [];
    }

    return Array.from({ length: 100 }, (_, i) => ({
      label: operations[sign](currentYear, i),
      value: operations[sign](currentYear, i),
    }));
  };

  const [titleError, setTitleError] = useState("");
  const [nameError, setFirstNameError] = useState("");

  const checkValidationsV0 = () => {
    if (!travellerData.title) {
      setTitleError("*Required");
      setTimeout(() => setTitleError(""), 3000); // Clear error after 3 seconds
    }
    if (!travellerData.first_name) {
      setFirstNameError("*Required");
      setTimeout(() => setFirstNameError(""), 3000); // Clear error after 3 seconds

      if (!travellerData.date_of_birth) {
        setDobError("*Required");
        setTimeout(() => setDobError(""), 3000); // Clear error after 3 seconds
      }
      return false;
    }

    return true; // If no errors
  };

  const [dobError, setDobError] = useState("");

  const checkValidationsV1 = () => {
    if (!travellerData.date_of_birth) {
      setDobError("*Required");
      setTimeout(() => setDobError(""), 3000); // Clear error after 3 seconds
      return false;
    }
    let dob = travellerData.date_of_birth.trim(); // Ensure no extra spaces

    // Check for incomplete date
    if (dob.includes("DD") || dob.includes("MM") || dob.includes("YYYY")) {
      setDobError("Incomplete Date");
      setTimeout(() => setDobError(""), 3000); // Clear error after 3 seconds
      return false;
    }

    // Check if dob is a future date
    let dobDate = new Date(dob);
    let today = new Date();

    if (dobDate > today) {
      setDobError("DOB Can't be a Future Date");
      setTimeout(() => setDobError(""), 3000); // Clear error after 3 seconds
      return false;
    }

    return true; // If no errors
  };

  let [issuanceDateError, setIssuanceDateError] = useState("");
  let [expiryDateError, setExpiryDateError] = useState("");

  const checkValidationsV2 = () => {
    if (
      travellerData.passport_issue_date == null &&
      travellerData.passport_expiry_date == null
    )
      return true;

    let status = 0;
    if (travellerData.passport_issue_date != null) {
      let issue = travellerData.passport_issue_date.trim(); // Ensure no extra spaces

      // Check for incomplete date
      if (
        issue.includes("DD") ||
        issue.includes("MM") ||
        issue.includes("YYYY")
      ) {
        setIssuanceDateError("Incomplete Date");
        setTimeout(() => setIssuanceDateError(""), 3000); // Clear error after 3 seconds
        status++;
      }

      // Check if dob is a future date
      let dobDate = new Date(issue);
      let today = new Date();

      if (dobDate > today) {
        setIssuanceDateError("Passport Issue Date Can't be a Future Date");
        setTimeout(() => setIssuanceDateError(""), 3000); // Clear error after 3 seconds
        status++;
      }
    }

    if (travellerData.passport_expiry_date != null) {
      let issue = travellerData.passport_expiry_date.trim(); // Ensure no extra spaces

      // Check for incomplete date
      if (
        issue.includes("DD") ||
        issue.includes("MM") ||
        issue.includes("YYYY")
      ) {
        setExpiryDateError("Incomplete Date");
        setTimeout(() => setExpiryDateError(""), 3000); // Clear error after 3 seconds
        status++;
      }

      // Check if dob is a future date
      let dobDate = new Date(issue);
      let today = new Date();

      if (dobDate <= today) {
        setExpiryDateError("Your Passport is Expired");
        setTimeout(() => setExpiryDateError(""), 3000); // Clear error after 3 seconds
        status++;
      }
    }

    return status == 0;
  };

  let [emailProvidedError, setEmailprovidedError] = useState("");
  let [numberProvidedError, setNumberprovidedError] = useState("");

  const validateEmail = (email) => {
    if (!email) {
      setEmailprovidedError("");
      return true;
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        setEmailprovidedError("Invalid email address");
        return false;
      } else if (email.includes("triprizer")) {
        setEmailprovidedError("Email address not allowed");
        return false;
      } else {
        setEmailprovidedError("");
        return true;
      }
    }
  };

  const validatePhoneNumber = (phoneNumber) => {
    if (!phoneNumber) {
      setNumberprovidedError("");
      return true;
    } else if (
      !isValidPhoneNumber(phoneNumber, seletedDialCodeCountry.data.code)
    ) {
      setNumberprovidedError("Invalid phone number");
      return false;
    } else {
      setNumberprovidedError("");
      return true;
    }
  };

  let getCountryValueDialCode = (val) => {
    if (!val) return { label: "Dial Code", value: null, data: null };

    return {
      label: `${val.data.code}:${val.data.phone}:${val.data.name}`,
      value: val.value,
      data: val.data,
    };
  };

  console.log("seletedDialCodeCountry is : ", seletedDialCodeCountry);


  let saveTheData = () => {

    let trvdata = { ...travellerData }
    // apply validations here and chekc them in the end do below
    let isAllValid0 = checkValidationsV0();
    let isAllValid1 = checkValidationsV1();
    let isAllValid2 = checkValidationsV2();
    let isAllValid3 = validateEmail(trvdata.email);
    let isAllValid4 = validatePhoneNumber(trvdata.phone_number);

    if (
      isAllValid0 == true &&
      isAllValid1 == true &&
      isAllValid2 == true &&
      isAllValid3 == true &&
      isAllValid4 == true
    ) {
      if (trvdata.phone_number != null || trvdata.phone_number != "") {
        onClickSave({ ...trvdata, dial_code_id: seletedDialCodeCountry.data.code });
      } else {
        onClickSave(trvdata);

      }
    }
  };

  return (
    <ul className="travellers-list-userdb">
      <li>
        <div className="traveller-accordion-header">
          <div className="traveller-left-data">
            <div className="traveller-ico-userdb">
              <img src={images["traveller-user-ico.svg"]} alt="" />
            </div>
            <div
              className="traveller-name-userdb"
              style={{ textTransform: "capitalize" }}
            >
              {travellerData.title} {travellerData.first_name}{" "}
              {travellerData.last_name}
            </div>
            <div className="traveller-type-userdb">
              {getMatureStatus(travellerData.date_of_birth)}
            </div>
          </div>
          <div className="traveller-right-data">
            <div className="editable-profile-action">
              <ul className="userdb-cta-buttons">
                <li
                  className="userdb-cancel-btn"
                  onClick={() => onClickCancel()}
                >
                  Cancel
                </li>
                <li className="userdb-save-btn" onClick={() => saveTheData()}>
                  Save
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="travellers-list-expanded-details">
          <div className="top-expanded-traveller">
            <div className="internal-tab-head">
              <h3>General Details</h3>
            </div>
            <ul className="myprofile-general-details">
              <li>
                <label for="">Name</label>
                <div
                  style={{
                    display: "flex",
                    width: "70%",
                    alignItems: "center",
                  }}
                >
                  <SelectTag
                    value={getTitleValue(travellerData.title)}
                    width="70px"
                    options={[
                      { label: "Title", value: null },
                      { label: "Mr", value: "Mr" },
                      { label: "Ms", value: "Ms" },
                      { label: "Mrs", value: "Mrs" },
                      { label: "Mstr", value: "Mstr" },
                    ]}
                    toSkip="Title"
                    dropdownWidth={"80px"}
                    onChange={(value) => onChangeTitle("title", value)}
                  />

                  <TextField
                    placeholder={"Enter Traveller's First Name"}
                    error={nameError}
                    focus={true}
                    onChange={onChangeInput}
                    name="first_name"
                    value={travellerData.first_name}
                  />
                  <TextField
                    placeholder={"Enter Traveller's Last Name"}

                    focus={true}
                    onChange={onChangeInput}
                    name="last_name"
                    value={travellerData.last_name}
                  />
                </div>

                {/* {
                  titleError
                } */}
              </li>
              <li>
                <label for="">Birthday</label>
                <div className="date-input-wrapper">
                  <div className="date-wrapper">
                    <SelectTag
                      value={getDateValue(
                        travellerData?.date_of_birth?.split("-")?.[2]
                      )}
                      options={[{ label: "DD", value: null }, ...days]}
                      toSkip="DD"
                      width="40px"
                      dropdownWidth={"60px"}
                      onChange={(value) => onChangeDate("day", value)}
                    />

                    <SelectTag
                      value={getMonthValue(
                        travellerData?.date_of_birth?.split("-")?.[1]
                      )}
                      width="40px"
                      options={months}
                      toSkip="MM"
                      dropdownWidth={"80px"}
                      onChange={(value) => onChangeDate("month", value)}
                    />

                    <SelectTag
                      value={getYearValue(
                        travellerData?.date_of_birth?.split("-")?.[0]
                      )}
                      width="60px"
                      options={[{ label: "YYYY", value: null }, ...years]}
                      toSkip="YYYY"
                      dropdownWidth={"80px"}
                      onChange={(value) => onChangeDate("year", value)}
                    />
                  </div>
                  {!!dobError && (
                    <div className="error font12 color_crimson proxima_regular">
                      {dobError}
                    </div>
                  )}
                </div>
              </li>
              <li>
                <label for="">Gender</label>
                <div style={{ display: "flex", width: "70%" }}>
                  <SelectTag
                    value={getGenderValue(travellerData.gender)}
                    width="70px"
                    options={[
                      { label: "Gender", value: null },
                      { label: "Male", value: "Male" },
                      { label: "Female", value: "Female" },
                      { label: "Other", value: "Other" },
                    ]}
                    toSkip="Gender"
                    dropdownWidth={"80px"}
                    onChange={(value) => onChangeGender("gender", value)}
                  />
                </div>
              </li>
              <li>
                <label for="">Email</label>
                <div style={{ display: "flex", width: "70%" }}>
                  <TextField
                    error={emailProvidedError}
                    placeholder={"Enter Traveller's Email"}
                    focus={true}
                    onChange={onChangeInput}
                    name="email"
                    value={travellerData.email}
                  />
                </div>
              </li>
              <li>
                <label for="">Mobile No.</label>
                <div style={{ display: "flex", width: "70%" }}>
                  {DialcodeCountries.length > 0 && (
                    <>
                      <CustomAutoCompleteWithImg
                        value={travellerData.dialCode || getCountryValueDialCode(seletedDialCodeCountry)}
                        options={DialcodeCountries}
                        toSkip="Dial Code"
                        width="50px"
                        dropdownWidth={"150px"}
                        onChange={(value) => onChangeDialCodeCountry(value)}
                      />
                      <TextField
                        error={numberProvidedError}
                        placeholder={"Enter Traveller's Phone Number"}
                        focus={true}
                        onChange={onChangeInput}
                        name="phone_number"
                        value={travellerData.phone_number?.split("-")?.[1] || travellerData.phone_number}
                      />
                    </>
                  )}
                </div>
              </li>
              <li>
                <label for="">RelationShip</label>

                <TextField
                  placeholder={"Enter Traveller's Relationship with you"}
                  focus={false}
                  onChange={onChangeInput}
                  name="relationship"
                  value={travellerData.relationship}
                />
              </li>
              <li>
                <label for="">Address</label>

                <TextField
                  placeholder={"Enter Traveller's Address"}
                  focus={false}
                  onChange={onChangeInput}
                  name="address"
                  value={travellerData.address}
                />
              </li>
              <li>
                <label for="">Pin Code</label>

                <TextField
                  placeholder={"Enter Traveller's PinCode"}
                  focus={false}
                  onChange={onChangeInput}
                  name="pincode"
                  value={travellerData.pincode}
                />
              </li>
              <li>
                <label for="">Country</label>
                <div style={{ display: "flex", width: "70%" }}>
                  <CustomAutoComplete
                    value={getCountryValue(travellerData.country)}
                    options={countries}
                    toSkip="Select Country"
                    width="50px"
                    dropdownWidth={"280px"}
                    onChange={(value) => onChangeCountry(value)}
                  />
                </div>
              </li>
              <li>
                <label for="">State</label>
                <div style={{ display: "flex", width: "70%" }}>
                  <CustomAutoComplete
                    value={getStatesValue(travellerData.state)}
                    options={states}
                    toSkip="Select State"
                    width="50px"
                    dropdownWidth={"300px"}
                    onChange={(value) => onChangeState(value)}
                  />
                </div>
              </li>
            </ul>
          </div>
          <div className="top-expanded-traveller">
            <div className="internal-tab-head">
              <h3>PASSPORT DETAILS</h3>
            </div>
            <ul className="myprofile-general-details">
              <li>
                <label for="">Passport No.</label>
                <div
                  style={{ display: "flex", width: "70%", marginLeft: "2px" }}
                >
                  <TextField
                    placeholder={"Enter Traveller's Passport Number"}
                    focus={true}
                    onChange={onChangeInput}
                    name="passport_number"
                    value={travellerData.passport_number}
                  />
                </div>
              </li>
              <li>
                <label for="">Passport Expiry Date</label>
                <div className="date-input-wrapper">
                  <div className="date-wrapper">
                    <SelectTag
                      value={getDateValue(
                        travellerData?.passport_expiry_date?.split("-")?.[2]
                      )}
                      options={[{ label: "DD", value: null }, ...days]}
                      toSkip="DD"
                      width="40px"
                      dropdownWidth={"60px"}
                      onChange={(value) =>
                        onChangeDateV2("day", value, "passport_expiry_date")
                      }
                    />

                    <SelectTag
                      value={getMonthValue(
                        travellerData?.passport_expiry_date?.split("-")?.[1]
                      )}
                      width="40px"
                      options={months}
                      toSkip="MM"
                      dropdownWidth={"80px"}
                      onChange={(value) =>
                        onChangeDateV2("month", value, "passport_expiry_date")
                      }
                    />

                    <SelectTag
                      value={getYearValue(
                        travellerData?.passport_expiry_date?.split("-")?.[0]
                      )}
                      width="60px"
                      options={[
                        { label: "YYYY", value: null },
                        ...getYears("+"),
                      ]}
                      toSkip="YYYY"
                      dropdownWidth={"80px"}
                      onChange={(value) =>
                        onChangeDateV2("year", value, "passport_expiry_date")
                      }
                    />
                  </div>
                  {!!expiryDateError && (
                    <div className="error font12 color_crimson proxima_regular">
                      {expiryDateError}
                    </div>
                  )}
                </div>
              </li>
              <li>
                <label for="">Passport Issue Date</label>
                <div className="date-input-wrapper">
                  <div className="date-wrapper">
                    <SelectTag
                      value={getDateValue(
                        travellerData?.passport_issue_date?.split("-")?.[2]
                      )}
                      options={[{ label: "DD", value: null }, ...days]}
                      toSkip="DD"
                      width="40px"
                      dropdownWidth={"60px"}
                      onChange={(value) =>
                        onChangeDateV2("day", value, "passport_issue_date")
                      }
                    />

                    <SelectTag
                      value={getMonthValue(
                        travellerData?.passport_issue_date?.split("-")?.[1]
                      )}
                      width="40px"
                      options={months}
                      toSkip="MM"
                      dropdownWidth={"80px"}
                      onChange={(value) =>
                        onChangeDateV2("month", value, "passport_issue_date")
                      }
                    />

                    <SelectTag
                      value={getYearValue(
                        travellerData?.passport_issue_date?.split("-")?.[0]
                      )}
                      width="60px"
                      options={[
                        { label: "YYYY", value: null },
                        ...getYears("-"),
                      ]}
                      toSkip="YYYY"
                      dropdownWidth={"80px"}
                      onChange={(value) =>
                        onChangeDateV2("year", value, "passport_issue_date")
                      }
                    />
                  </div>
                  {!!issuanceDateError && (
                    <div className="error font12 color_crimson proxima_regular">
                      {issuanceDateError}
                    </div>
                  )}
                </div>
              </li>
              <li>
                <label for="">Issuing Country</label>
                <div
                  style={{ display: "flex", width: "70%", marginLeft: "2px" }}
                >
                  <CustomAutoComplete
                    value={getCountryValue(
                      travellerData.passport_issuing_country
                    )}
                    options={countries}
                    toSkip="Select Country"
                    width="50px"
                    dropdownWidth={"280px"}
                    onChange={(value) => onChangeCountry(value)}
                  />
                </div>
              </li>
            </ul>
          </div>
        </div>
      </li>
    </ul>
  );
}

export default TravellerForm;
